import {
    removeToken,
    removeNameAndValue,
    getNameAndValue
} from "./localStorage";
import {
    Message
} from "element-ui";

export function encodeString(para) {
    return escape(para);
}


export function clearCache() {
    removeToken();
    removeNameAndValue("info");
    removeNameAndValue("subscription");
    removeNameAndValue("frequency");
    removeNameAndValue("searchData");
    removeNameAndValue("customSymbls");
    removeNameAndValue("id");
}

export function logout(self) {
    clearCache();
    self.$router.push({
        path: "/login"
    });
}

export function stringToHundredMillion(num) {
    let result = "";
    if (/^[0-9.]+$/.test(num) && num.toString().length > 5) {
        num = parseFloat(num);
        result = (num / 100000000).toFixed(2);
        result = result + "亿";
    } else {
        result = num;
    }
    return result;
}

export function checkResponseStatus(data, self) {
    let isFineForStatus = true;
    if (data._meta !== undefined && data._meta.response_status !== undefined &&
        Number(data._meta.response_status) > 200000 && Number(data._meta.response_status) < 300000) {
        isFineForStatus = true;
    } else {
        if (data._meta !== undefined && data._meta.response_status !== undefined) {
            switch (data._meta.response_status) {
                case 400001:
                case 400004:
                    Message({
                        message: "身份验证失败，请尝试登录！", //Login failed
                        type: "error",
                        duration: 3 * 1000
                    });
                    Message.close = function() {
                    };
                    logout(self);
                    isFineForStatus = false;
                    break;
                case 400006:
                    Message({
                        message: "用户名错误或不存在！", //Login failed
                        type: "error",
                        duration: 3 * 1000
                    });
                    Message.close = function() {
                    };
                    logout(self);
                    isFineForStatus = false;
                    break;
                case 400007:
                    Message({
                        message: "请输入正确的密码！", //Login failed
                        type: "error",
                        duration: 3 * 1000
                    });
                    Message.close = function() {
                    };
                    logout(self);
                    isFineForStatus = false;
                    break;
                case 400008:
                    Message({
                        message: "MFA权限故障，请联系chinaclientsupport@morningstar.com！", //Login failed
                        type: "error",
                        duration: 3 * 1000
                    });
                    Message.close = function() {
                    };
                    logout(self);
                    isFineForStatus = false;
                    break;
                case 400003:
                    Message({
                        message: "数据异常，请稍后再试！", //Invalid data request
                        type: "error",
                        duratiisFineForStatuson: 3 * 1000
                    });
                    Message.close = function() {
                    };
                    //logout(self);
                    isFineForStatus = false;
                    break;
                case 200:
                case 200200:
                    Message({
                        message: "服务器异常，请稍后再试！",
                        type: "error",
                        duration: 3 * 1000
                    });
                    Message.close = function() {
                        //self.loadInfoData();
                    };
                    isFineForStatus = false;
                    break;
                case 500:
                    Message({
                        message: "服务器超时，请稍后再试！",
                        type: "error",
                        duration: 3 * 1000
                    });
                    Message.close = function() {
                        //self.loadInfoData();
                    };
                    isFineForStatus = false;
                    break;
                case 400034:
                case 400032:
                    isFineForStatus = true;
                    break;
                case 400011:
                    isFineForStatus = false;
                    break;
                case 400012:
                default:
                    Message({
                        message: "数据找不到，请稍后再试！", //Sales suitability cloud not be found
                        type: "error",
                        duration: 3 * 1000
                    });
                    Message.close = function() {
                        //self.loadInfoData();
                    };
                    isFineForStatus = false;
                    break;
            }
        }
    }
    return isFineForStatus;
}

export function getCurrentDate() {
    var date = new Date();
    return getDateByStandardFormat(date);
}

export function getDateByStandardFormat(date) {
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
}

export function routerPush(value,self) {
    let linkExist=false;
    let tempIndex=-1;
    let bb = self.$router.options.routes;
    // bb.forEach(function(item,index){
    //   if(item.path == value)
    //   {                  
    //     linkExist=true;        
    //     // self.$router.options.routes.pop(item);//it is not work.
    //     tempIndex=index;
    //   }
    // }); 
    //和上面循环方法一样，但是上面不能添加break。另外有说有every等循环来return方法，但是测试过不行
    for(let i=0;i<bb.length;i++)
    {
        if(bb[i].path == value)
        {                  
          linkExist=true;                  
          tempIndex=i;
          break;
        }
    }
    
    if(linkExist && tempIndex!=-1)
    {
    //   self.$router.options.routes.pop(value);//it is not work.
      self.$router.options.routes.splice(tempIndex,1);
    }
    
    self.$router.push({
        path: value
    }); 
}


export function getDisableExport() {
    let userInfo = getNameAndValue("info");
    if (userInfo != undefined && userInfo != null && userInfo != "") {
        const user = JSON.parse(userInfo);

        if (user.userStatus != undefined && user.userStatus != null 
            && user.userStatus != "" && user.userStatus == "0") {
            return false;
        }
        else{
            return true;
        }
    }
    else
    {
        return true;
    }
}

export function getSuitabilityMemberBaseTrial() {
    let userInfo = getNameAndValue("info");
    if (userInfo != undefined && userInfo != null && userInfo != "") {
        const user = JSON.parse(userInfo);
                 
        if (user.suitabilityMemberBaseTrial != undefined && user.suitabilityMemberBaseTrial != null 
            && user.suitabilityMemberBaseTrial) {
            return true;
        }
        else{
            return false;
        }
    }
    else
    {
        return false;
    }
}

export function getSuitabilityMemberBase() {
    let userInfo = getNameAndValue("info");
    if (userInfo != undefined && userInfo != null && userInfo != "") {
        const user = JSON.parse(userInfo);
                 
        if (user.suitabilityMemberBase != undefined && user.suitabilityMemberBase != null 
            && user.suitabilityMemberBase) {
            return true;
        }
        else{
            return false;
        }
    }
    else
    {
        return false;
    }
}

export function getSuitabilityMemberSeniorTrial() {
    let userInfo = getNameAndValue("info");
    if (userInfo != undefined && userInfo != null && userInfo != "") {
        const user = JSON.parse(userInfo);
                 
        if (user.suitabilityMemberSeniorTrial != undefined && user.suitabilityMemberSeniorTrial != null 
            && user.suitabilityMemberSeniorTrial) {
            return true;
        }
        else{
            return false;
        }
    }
    else
    {
        return false;
    }
}

export function getSuitabilityMemberSenior() {
    let userInfo = getNameAndValue("info");
    if (userInfo != undefined && userInfo != null && userInfo != "") {
        const user = JSON.parse(userInfo);
                 
        if (user.suitabilityMemberSenior != undefined && user.suitabilityMemberSenior != null 
            && user.suitabilityMemberSenior) {
            return true;
        }
        else{
            return false;
        }
    }
    else
    {
        return false;
    }
}

export function getRankingMemberBaseTrial() {
    let userInfo = getNameAndValue("info");
    if (userInfo != undefined && userInfo != null && userInfo != "") {
        const user = JSON.parse(userInfo);
                 
        if (user.rankingMemberBaseTrial != undefined && user.rankingMemberBaseTrial != null 
            && user.rankingMemberBaseTrial) {
            return true;
        }
        else{
            return false;
        }
    }
    else
    {
        return false;
    }
}

export function getRankingMemberBase() {
    let userInfo = getNameAndValue("info");
    if (userInfo != undefined && userInfo != null && userInfo != "") {
        const user = JSON.parse(userInfo);
                 
        if (user.rankingMemberBase != undefined && user.rankingMemberBase != null 
            && user.rankingMemberBase) {
            return true;
        }
        else{
            return false;
        }
    }
    else
    {
        return false;
    }
}

export function getRankingMemberSeniorTrial() {
    let userInfo = getNameAndValue("info");
    if (userInfo != undefined && userInfo != null && userInfo != "") {
        const user = JSON.parse(userInfo);
                 
        if (user.rankingMemberSeniorTrial != undefined && user.rankingMemberSeniorTrial != null 
            && user.rankingMemberSeniorTrial) {
            return true;
        }
        else{
            return false;
        }
    }
    else
    {
        return false;
    }
}

export function getRankingMemberSenior() {
    let userInfo = getNameAndValue("info");
    if (userInfo != undefined && userInfo != null && userInfo != "") {
        const user = JSON.parse(userInfo);
                 
        if (user.rankingMemberSenior != undefined && user.rankingMemberSenior != null 
            && user.rankingMemberSenior) {
            return true;
        }
        else{
            return false;
        }
    }
    else
    {
        return false;
    }
}

export function getMyListTypeByCustom() {
    let userInfo = getNameAndValue("info");
    if (userInfo != undefined && userInfo != null && userInfo != "") {
        const user = JSON.parse(userInfo);
                 
        if (user.myListType != undefined && user.myListType != null 
            && user.myListType == 0) {
            return true;
        }
        else{
            return false;
        }
    }
    else
    {
        return false;
    }
}

export default checkResponseStatus;